<section id="why-us" class="clearfix">
  <div class="container">

    <header class="section-header">
      <h1 class="section-title" style="text-align: center;">Blockchain Technology</h1>
    </header>

    <div class="row about-container">

      <div class="col-lg-12 content order-lg-1 order-2">
       
        <div class="icon-box wow fadeInUp">
        
          <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="color: maroon;"><b>Blockchain Technology</b></span> is a structure in that store transactional details. 
            Blockchain is growing list of records, called blocks and they are linked together called chain. Blockchain is defined as that contains information. 
            This technique is intended to timestamp digital documents, so it’s not possible to backdate them. This blockchain is used to transfer contents like, money, properties, contract, etc.
             without requiring third party like bank or government. Once data is uploaded or inserted in blockchain then it is too much difficult to change it. This technology is managed by peer to peer network for use of publically. 
             In this article you we are sharing you some things about Blockchain like Blockchain technology, how blockchain work, why it’s important, and how you can use it.</p>
        </div>    

        <div class="icon-box wow fadeInUp">
            
          <h4 class="title"><a href="">What is Blockchain Technology?</a></h4>
          <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Blockchain technology is a structure that stores the transaction records. 
            Typically storage is referred as ‘digital ledger’. In this ledger every transaction is authorized by the digital signature by the owner, which authenticates the transaction and protects it from tampering. Therefore, information with a digital ledger is extremely secure.  </p>
        </div>

        <div class="icon-box wow fadeInUp">
          <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;In simple words in blockchain technology is used for the storing transactional history by using digital ledger. 
            Digital ledger is like Google spreadsheet which is shared various computers in a network. In which all transactional records are stored on actual purchased. Main feature or we can say fascinating angle is that anybody can see data, 
            but no one can corrupt it. In short blockchain is an incorruptible chain of box where each blogs contain data of value which is connected or validated by all nodes in the network, not by any central node. When any transactional information is stored in that blockchain can never be deleted or altered. 
            Instead new block added to the chain to update the information. 
          </p>
        </div>

        <div class="icon-box wow fadeInUp">
            
          <h4 class="title"><a href="">Why Blockchain is popular?</a></h4>
          <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Suppose you are transferring money from your bank account to your family or friends. 
            You will log in to online banking and transfer the amount to another person using their account number. Your bank updates the transaction record when the transaction is completed. 
            That sounds simple enough, right? There is a potential issue that most of us ignore. Blockchain will be used in <b>core banking</b> while at the time of transferring or any transaction time. 
            This type of transaction is happen very quickly, those people who are familiar with this type of transaction, hence the evolution of third party payment application or <b>software developed</b> in recent year, but this insecurity is why blockchain technology was originally created.
          </p>
        </div>

        <div class="icon-box wow fadeInUp">
            
          <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;In blockchain technology there will be all record keeping of data and transaction are a crucial part. 
            Often, this information is handled at home or provided by third parties such as brokers, bankers or lawyers, raising business, time or cost. Fortunately, blockchain avoids this long process and facilitates faster movement of transactions, 
            which saves time and money.
          </p>
        </div>

        <div class="icon-box wow fadeInUp">
            
          <h4 class="title"><a href="">Advantages of Blockchain</a></h4>
          <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Blockchain is important technology with many advantages in an increasingly digital word. Let see advantages of blockchain.
          </p>
        </div>

        <div class="icon-box wow fadeInUp">
            <ul>
              <li><b> Decentralized system : </b>
                <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  Traditionally, the transaction requires the approval of regulatory authorities such as the government or a bank; however, with blockchain, transactions are conducted with the mutual consent of users resulting in smoother, safer and faster transactions.
                </p>
              </li>
              <li><b> Highly secure: </b>
                <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  It uses the digital signature feature to conduct fraud-free transactions by making it impossible for other users to corrupt or alter a person's data without a digital signature.
                </p>
              </li>
              <li><b> Capability: </b>
                <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  Capability is depend upon of software development or programmable and generate the automatic systematic actions, events and payment when criteria of trigger is met .
                </p>
              </li>
            </ul>

        </div>
        
        <div class="icon-box wow fadeInUp">
            
          <h4 class="title"><a href="">How blockchain is used in software industry?</a></h4>
          <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Blockchain uses a distributed database to maintain all records to make it accessible and secure for everyone. This technology is safe and takes care of unauthorized access. It is secured and robust technology that is used for developing <b>software application</b>.
          </p>
        </div>

        <div class="icon-box wow fadeInUp">
          <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;In software development anyone can use the blockchain for adding and view record in the database but can’t delete or modify the record into database. It is used in finance industry, or core banking software where security is an essential part of each transaction is in company.
          </p>
        </div>

        <div class="icon-box wow fadeInUp">
            
          <h4 class="title"><a href="">How Does Blockchain Technology work?</a></h4>
          <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Recent years you may have noticed many businesses around the world integrating blockchain technology. 
          </p>
        </div>
        <div class="icon-box wow fadeInUp">
          <p class="description" style="text-align: justify;" >Blockchain is a combination of three technologies
          </p>
        </div>
        <div class="icon-box wow fadeInUp">
          <ul>
            <li>Cryptographic keys</li>
            <li>A peer-to-peer network   </li>
            <li>Computing, means store the all records of the network </li>
          </ul>

      </div>

      <div class="icon-box wow fadeInUp">
            
        <p class="description" style="text-align: justify;" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Cryptographic Keys In that there is consist private key and public key. This both keys help performing successful transaction between two parties, 
          and this type of security is important at the time of transaction that’s why blockchain is so popular in now a days. Digital signature is important part of blockchain and this digital signature is merged with peer-to-peer network. When they authorize a transaction, it is verified by mathematical verification, which leads to successful secure transactions between the two network-connected parties. To summarize, blockchain users on peer-to-peer networks use cryptography keys to perform a variety of digital interactions.
        </p>
      </div>
    </div>
    </div>
  </div>

</section>